// @ts-nocheck

import React from "react";

interface GenericCardProps {
  title: string;
  value: number | string;
  unit?: string;
}

export function CardGenerico({ title, value, unit = "" }: GenericCardProps) {
  // Formatar o valor se for um número
  const formattedValue = typeof value === "number" ? value.toFixed(2) : value;

  // 32
  return (
    <div
      className="
    h-16
    bg-gray-50 dark:bg-gray-350 rounded-lg 
    w-full flex flex-col overflow-visible"
    >
      <div
        className="
      bg-gray-100 
      dark:bg-gray-400 
      h-8 
      p-0.5 md:p-2
      rounded-t-md"
      >
        <p
          className="
        font-normal dark:text-gray-100 text-gray-500
        text-xs
        "
        >
          {title}
        </p>
      </div>
      <div className="h-full flex items-center justify-center">
        <div
          className="
        text-2xl 
        font-bold
        "
        >
          {formattedValue} {unit}
        </div>
      </div>
    </div>
  );
}
